export { default as FactorContinueModal } from './Continue'
export { default as FactorDeleteModal } from './Delete'
export { default as FactorSkipModal } from './Skip'



// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Modals/index.js